import { gql } from '@apollo/client';

const MESSAGE_FRAGMENT = gql`
  fragment MessageFragment on Message {
    id
    status
    createdAt
    message
    from {
      id
      firstName
      lastName
      avatar {
        id
        thumbnailPipeFrom
      }
    }
    chatRoom {
      id
    }
    #   appointment {
    #     id
    #     description
    #     date
    #   }
    # }
  }
`;

export default MESSAGE_FRAGMENT;
